import { useLoaderData, useParams, Navigate, useNavigate } from "react-router-dom";
import logo from '../assets/images/mimararchi.png';
// import card from '../assets/images/black-card.png';
// import userImg from '../assets/images/myaf.jpg';
import Platform from '../components/Platform';
import BusinessLinks from '../components/BusinessLinks';
import axios from 'axios';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import Button from '@mui/material/Button';
import { useState } from "react";
import CircularProgress from '@mui/material/CircularProgress';
import swal from 'sweetalert';
import BlueProfile from "../components/BlueProfile";
import RedProfile from "../components/RedProfile";
import power from "../assets/images/power.jpg";
const Profile = () => {
    const navigate = useNavigate();
    const user = useLoaderData();
    const [isLoading, setIsLoading] = useState(false)

    console.log(user)
    if (!user)
        navigate('/error')
    let profile = user.profiles[user.activeProfile]
    const { id } = useParams()
    const { Name } = useParams()
    let c;
    if (profile.colorTheme === '#d9d9d9') {
        c = '217, 217, 217'
    }
    else {
        c = profile.colorTheme
    }
    const [email, setEmail] = useState('');
    const [name, setName] = useState('');
    const [phone, setPhone] = useState('');
    const [notes, setNotes] = useState('');
    const [showMore, setShowMore] = useState(false);
    const [pokeOpen, setPokeOpen] = useState(false);
    const handlePokeOpen = () => setPokeOpen(true);
    const handlePokeClose = () => setPokeOpen(false);
    console.log(user.name)
    if (user.name === 'null' || user.email === 'null') {
        console.log("ddd")
        const url = `/newUserInfo/${id}`
        return <Navigate to={url} replace={true} />
    }

    const handleContactSaveAnalytics = async () => {
        const formData = new FormData();
        formData.append('id', id);
        formData.append('Name', Name);
        await axios.post(`/analytics/contactTap`, formData, {
            withCredentials: true,
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                "X-Requested-With": "XMLHttpRequest",
            },
        })
            .then(async (res) => {
                const json = res.data
                console.log(json)
            })
            .catch((err) => {
                console.log("No internet Connection")
            })

    }

    const handleShare = async (e) => {
        e.preventDefault()
        setIsLoading(true)
        handlePokeClose()
        const formData = new FormData();
        formData.append('Id', id);
        formData.append('Name', name);
        formData.append('Number', phone);
        formData.append('Email', email);
        formData.append('Notes', notes);
        formData.append('profileName', Name);

        await axios.post(`/users/clientsContactsUpdate`, formData, {
            withCredentials: true,
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                "X-Requested-With": "XMLHttpRequest",
            },
        })
            .then(async (res) => {
                const json = res.data
                console.log(json)
            })

        const formData2 = new FormData();
        formData2.append('id', id);
        formData2.append('Name', Name);

        await axios.post(`/analytics/exchangeTap`, formData2, {
            withCredentials: true,
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                "X-Requested-With": "XMLHttpRequest",
            },
        })
            .then(async (res) => {
                const json = res.data
                console.log(json)
                setIsLoading(false)
                swal({
                    title: "Contact sent successfuly",
                    icon: "success",
                    button: "Continue Exploring",
                  });
            })
            
    }
    console.log(user)
    return (
        <div style={{ 'minHeight': '100vh', 'borderRadius': '0', "cursor": 'auto' }} className="profileContainer">
            <Modal open={pokeOpen} onClose={e => handlePokeClose(e)}>
                <Box className="exMUI">
                    <div className="exchangeFormHolder">
                        <div></div>
                        <div>
                            <div className="imgHolder-exchange">
                                <img className="mocketImage-exchange" src={profile.image1} alt="Profile" />
                            </div>
                        </div>
                        <p style={{ 'textAlign': 'center', 'fontFamily': 'poppins-bold' }}>Share your info with <br /> {user.name}</p>
                        <form className="exchangeForm" onSubmit={handleShare}>
                            <input
                                type="tex"
                                placeholder="Name"
                                onChange={(e) => setName(e.target.value)}
                                value={name}
                                required
                            />
                            <input
                                type="text"
                                placeholder="Phone"
                                onChange={(e) => setPhone(e.target.value)}
                                value={phone}
                                required
                            />
                            <input
                                type="email"
                                placeholder="Email"
                                onChange={(e) => setEmail(e.target.value)}
                                value={email}
                            />
                            <textarea value={notes} onChange={(e) => setNotes(e.target.value)} placeholder="Notes" rows="4" cols="30" />

                            <button type="submit"> {!isLoading&&'Share'} {isLoading&&<CircularProgress />}  </button>
                        </form>
                    </div>
                </Box>
            </Modal>
            <div className="imgBundleContainer" style={{"background": user.type === 'Blue' ? "linear-gradient(to top, white 0%, white 42%, #172c3d 42%, #172c3d 100% )": "white"}}>
                {
                    user.type === "Blue" ? <BlueProfile job={profile.job} name={user.name} image1={profile.image1} /> : <RedProfile job={profile.job} name={user.name} image1={profile.image1} />
                }
            </div>
            
            <div className={user.type ==="Blue" ?"contactButtonsBlue":"contactButtons"}>
                {
                    (profile.contact_link === 'false') ? <a style={{"fontFamily":user.type ==="Blue"? "neufile-info":"sans-title"}} onClick={(event) => event.preventDefault()}  href={profile.contact_link}> Save Contact </a> :
                        <a style={{"fontFamily":user.type ==="Blue"? "neufile-info":"sans-title"}} onClick={handleContactSaveAnalytics}  href={profile.contact_link}> Save Contact </a>
                }
                <Button style={{ "textTransform":"unset", 'color': user.type === "Blue"? 'white':"black" , "background": user.type === "Blue"? "#172c3d":"#972721" ,"fontFamily":user.type ==="Blue"? "neufile-info !impostant":"sans-title !impostant" }} className={user.type ==="Blue" ?'taskOpenBtnExBlue':"taskOpenBtnEx"} onClick={handlePokeOpen}>
                    <span   className="exchangeButton">  Exchange Contact </span>
                </Button>
            </div>
            <p style={{"width":"90%","marginBottom":"0px"}}>
                Contact Info
            </p>
            <div className="businessLinkHolder">
                {profile.socialMedia && profile.socialMedia.map((app, index) => (
                    <BusinessLinks corp={false} key={index} props={app} color={profile.colorTheme} idx={index} />
                ))}
            </div>
            <div style={{"width":"90%", "textAlign":"right" ,"padding":"10px","marginTop":"40px"}}>
                <img style={{"width":"30%"}} src={power}/>
            </div>
        </div>
    );
}
export default Profile;

export const ProfileDetailsLoader = async ({ params }) => {
    const { id } = params
    let res, json
    try {
        res = await axios.get('/profile/id/' + id, {
            withCredentials: true,
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                "X-Requested-With": "XMLHttpRequest",
            },
        })
    }
    catch (err) {
        console.log("No internet Connection")
        return null
    }
    return res.data
}

export const OldProfileDetailsLoader = async ({ params }) => {
    const { Name } = params
    let res, json
    try {
        res = await axios.get('/profile/' + Name, {
            withCredentials: true,
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                "X-Requested-With": "XMLHttpRequest",
            },
        })
    }
    catch (err) {
        console.log("No internet Connection")
        return null
    }
    console.log(res)
    return res.data
}